// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"519":"locale-sl-json","551":"locale-en-json"}[chunkId] + "-legacy." + {"519":"904f3fc1","551":"c43392d5"}[chunkId] + ".js";
};